import { render, staticRenderFns } from "./VAuth.vue?vue&type=template&id=50d6f986&scoped=true&"
import script from "./VAuth.vue?vue&type=script&lang=js&"
export * from "./VAuth.vue?vue&type=script&lang=js&"
import style0 from "./VAuth.vue?vue&type=style&index=0&id=50d6f986&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d6f986",
  null
  
)

export default component.exports